// @flow
export { default } from './ZipcodeInput';
export type { Props } from './ZipcodeInput';



// WEBPACK FOOTER //
// ../react-lib/src/components/formFields/ZipcodeInput/index.js